var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"none","d":"M15.75 5L9 11.75L15.75 18.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }